import { api, captureIdentity, isCurrentIdentity } from './client';
import type { ReportQuery, ReportResult } from '../types/reports';

export const reportsApi = {
  get: (reportType: string, query: ReportQuery) =>
    api.get<ReportResult>(`/reports/${reportType}`, { params: query }).then((r) => r.data),

  exportCsv: async (reportType: string, query: ReportQuery) => {
    const identity = captureIdentity();
    const res = await api.get(`/reports/${reportType}/export`, { params: query, responseType: 'blob' });
    if (!isCurrentIdentity(identity)) return;
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${reportType}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
